import { ApplicationInsights } from '@microsoft/applicationinsights-web';

type TelemetryConfig = {
  connectionString: string;
  appName: string;
};

let appInsights: ApplicationInsights | undefined;

export function initTelemetry(config: TelemetryConfig): ApplicationInsights {
  if (appInsights) {
    return appInsights;
  }

  const instrumentationKey = config.connectionString
    .split(';')
    .find(part => part.startsWith('InstrumentationKey='))
    ?.split('=')[1] ?? '';

  appInsights = new ApplicationInsights({
    config: {
      connectionString: config.connectionString,
      instrumentationKey,
      enableAutoRouteTracking: false,
      autoTrackPageVisitTime: true,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
      correlationHeaderDomains: ['*.norlights.com', '*.azurecontainerapps.io'],
      disableExceptionTracking: false,
      sessionRenewalMs: 30 * 60 * 1000,
      sessionExpirationMs: 24 * 60 * 60 * 1000,
      maxBatchSizeInBytes: 10000,
      maxBatchInterval: 15000,
    },
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags ?? [];
    envelope.tags['ai.cloud.role'] = config.appName;
  });

  return appInsights;
}

export function trackPageView(name: string, uri: string) {
  appInsights?.trackPageView({ name, uri });
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  appInsights?.trackEvent({ name }, properties);
}
